import { List, ListItem } from 'foundations-components/transitional/components/List';
import { Button } from 'foundations-components/transitional/components/Button';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { jsx as _jsx } from "react/jsx-runtime";
export const MacrosMenuList = ({
  macros,
  onSelectMacro
}) => {
  return /*#__PURE__*/_jsx(List, {
    children: macros.map(macro => /*#__PURE__*/_jsx(ListItem, {
      children: /*#__PURE__*/_jsx(Tooltip, {
        title: macro.description,
        disabled: !macro.description,
        children: /*#__PURE__*/_jsx(Button, {
          onClick: () => onSelectMacro(macro),
          children: macro.name
        })
      })
    }, macro.id))
  });
};
MacrosMenuList.displayName = 'MacrosMenuList';